import React from 'react'
import BottomSheetContent from './BottomSheetContent'
import RenderHTML from '../ui-components/RenderHTML'
import EliteLandingPageEliteRemark from '../elite/EliteLandingPageEliteRemark'

interface EliteLandingPageKnowWhyContentProps {
  onDismiss: () => void
}

export const EliteLandingPageKnowWhyContent: React.FC<EliteLandingPageKnowWhyContentProps> = ({ onDismiss }) => {
  const heading = 'How do we consistently deliver alpha for Elite members?'

  return (
    <BottomSheetContent
      heading={heading}
      bottomSheetHeadingClassName='!text-[#3D3D3D] !font-[500] !leading-[140%]'
      onDismiss={onDismiss}
      bottomSheetCtas={
        <button
          onClick={() => {
            onDismiss()
          }}
          className='w-full py-2 px-4 bg-[#232323] text-white font-medium rounded-xl h-14 outline-none focus:outline-none'
        >
          Go back
        </button>
      }
    >
      <div className='flex flex-col gap-6'>
        <div className='text-[#6A6E6E] text-[14px] font-[400] leading-[150%]'>
          Elite insights are powered by institutional-grade research — blending data, insight, and expert judgment.
        </div>

        <ul className='flex flex-col gap-4 text-[14px] font-[500] leading-[150%] text-[#3D3D3D] list-none m-0 p-0'>
          <li className='flex list-none'>
            <div className='mr-3 mt-[6px]' aria-hidden='true'>
              <RenderHTML innerHTMLText={magnifierIcon} />
            </div>
            <span>20+ yrs of fund performance, risk, and consistency</span>
          </li>
          <li className='flex list-none'>
            <div className='mr-3 mt-[6px]' aria-hidden='true'>
              <RenderHTML innerHTMLText={forwardIcon} />
            </div>
            <span>Forward-looking signals — not just past returns</span>
          </li>
          <li className='flex list-none'>
            <div className='mr-3 mt-[6px]' aria-hidden='true'>
              <RenderHTML innerHTMLText={userIcon} />
            </div>
            <span>Fund manager track record and macro context</span>
          </li>
          <li className='flex list-none'>
            <div className='mr-3 mt-[6px]' aria-hidden='true'>
              <RenderHTML innerHTMLText={calendarIcon} />
            </div>
            <span>Reviewed monthly by SEBI-registered experts</span>
          </li>
          <li className='flex list-none'>
            <div className='mr-3 mt-[6px]' aria-hidden='true'>
              <RenderHTML innerHTMLText={timeIcon} />
            </div>
            <span>Backtested. Proven. Reliable.</span>
          </li>
        </ul>

        <div className='mt-2'>
          <EliteLandingPageEliteRemark isElite={true}>
            <div className='text-[14px] font-[500] leading-[150%]'>
              Our back-testing results have consistently delivered 2-4% higher returns — that’s what it means to invest
              like the top 1%.
            </div>
          </EliteLandingPageEliteRemark>
        </div>
      </div>
    </BottomSheetContent>
  )
}

const magnifierIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <g clip-path="url(#clip0_33257_62151)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.33594 6.1237C2.33594 4.02962 4.03353 2.33203 6.1276 2.33203C8.22171 2.33203 9.91927 4.02962 9.91927 6.1237C9.91927 8.21781 8.22171 9.91536 6.1276 9.91536C4.03353 9.91536 2.33594 8.21781 2.33594 6.1237ZM6.1276 0.582031C3.06702 0.582031 0.585938 3.06312 0.585938 6.1237C0.585938 9.18427 3.06702 11.6654 6.1276 11.6654C7.3421 11.6654 8.46537 11.2746 9.37858 10.6121L12.1818 13.4154L13.4193 12.1779L10.616 9.37467C11.2786 8.46146 11.6693 7.3382 11.6693 6.1237C11.6693 3.06312 9.18818 0.582031 6.1276 0.582031Z" fill="#CC5C2D"/>
  </g>
  <defs>
    <clipPath id="clip0_33257_62151">
      <rect width="14" height="14" fill="white"/>
    </clipPath>
  </defs>
</svg>`

const forwardIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <g clip-path="url(#clip0_33257_62156)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.83594 10.9689L9.72835 7.43033C9.84991 7.31979 9.91927 7.16304 9.91927 6.99872C9.91927 6.83434 9.84991 6.67765 9.72835 6.56705L5.83594 3.02854V1.16537C5.83594 0.93448 5.97215 0.72532 6.18325 0.631911C6.39442 0.5385 6.64082 0.578428 6.81168 0.733743L13.2283 6.56705C13.3499 6.67765 13.4193 6.83434 13.4193 6.99872C13.4193 7.16304 13.3499 7.31979 13.2283 7.43033L6.81168 13.2637C6.64082 13.419 6.39442 13.4589 6.18325 13.3655C5.97215 13.2721 5.83594 13.0629 5.83594 12.8321V10.9689Z" fill="#CC5C2D"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.585938 12.8321C0.585938 13.0629 0.722129 13.2721 0.933284 13.3655C1.14444 13.4589 1.39082 13.419 1.56166 13.2637L7.97835 7.43033C8.09991 7.31979 8.16927 7.16304 8.16927 6.99872C8.16927 6.83434 8.09991 6.67765 7.97835 6.56705L1.56166 0.733743C1.39082 0.578428 1.14444 0.5385 0.933284 0.631911C0.722123 0.72532 0.585938 0.93448 0.585938 1.16537L0.585938 12.8321Z" fill="#CC5C2D"/>
  </g>
  <defs>
    <clipPath id="clip0_33257_62156">
      <rect width="14" height="14" fill="white"/>
    </clipPath>
  </defs>
</svg>`

const userIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <g clip-path="url(#clip0_33257_62162)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.50195 4C3.50195 2.067 5.06896 0.5 7.00195 0.5C8.93495 0.5 10.502 2.067 10.502 4C10.502 5.933 8.93495 7.5 7.00195 7.5C5.06896 7.5 3.50195 5.933 3.50195 4ZM7.00184 8.5C4.0891 8.5 1.59302 10.2789 0.538521 12.8076C0.474166 12.9619 0.491208 13.1382 0.583935 13.2773C0.676662 13.4164 0.832799 13.5 1 13.5H13.0037C13.1709 13.5 13.3271 13.4164 13.4198 13.2773C13.5125 13.1382 13.5296 12.9619 13.4652 12.8076C12.4107 10.2789 9.91457 8.5 7.00184 8.5Z" fill="#CC5C2D"/>
  </g>
  <defs>
    <clipPath id="clip0_33257_62162">
      <rect width="14" height="14" fill="white"/>
    </clipPath>
  </defs>
</svg>`

const calendarIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <g clip-path="url(#clip0_33257_62168)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.79167 0.4375C3.68932 0.4375 3.59783 0.440189 3.51622 0.444806C3.05556 0.470846 2.79746 0.852903 2.78345 1.27034C2.77904 1.40175 2.77522 1.5527 2.77297 1.72047C2.63105 1.72947 2.49866 1.73857 2.3756 1.74762C1.41997 1.81789 0.668442 2.54543 0.586177 3.50706C0.511712 4.37757 0.4375 5.71398 0.4375 7.58333C0.4375 9.45265 0.511709 10.7891 0.586174 11.6596C0.668436 12.6212 1.41996 13.3488 2.3756 13.419C3.32859 13.4891 4.84178 13.5625 7 13.5625C9.15822 13.5625 10.6714 13.4891 11.6244 13.4191C12.58 13.3488 13.3316 12.6212 13.4138 11.6596C13.4883 10.7891 13.5625 9.45265 13.5625 7.58333C13.5625 5.71401 13.4883 4.37757 13.4138 3.50706C13.3316 2.54543 12.58 1.81789 11.6244 1.74762C11.5013 1.73857 11.3689 1.72947 11.227 1.72048C11.2248 1.5527 11.221 1.40175 11.2165 1.27034C11.2025 0.852903 10.9444 0.470846 10.4838 0.444806C10.4022 0.440189 10.3107 0.4375 10.2083 0.4375C10.106 0.4375 10.0145 0.440189 9.93288 0.444806C9.47223 0.470846 9.21413 0.852903 9.20013 1.27034C9.19648 1.37819 9.19327 1.49921 9.191 1.63189C8.82849 1.62222 8.43742 1.61461 8.01695 1.60983C8.01471 1.48577 8.01165 1.37218 8.0082 1.27034C7.9942 0.852903 7.73611 0.470846 7.27545 0.444806C7.19384 0.440189 7.10235 0.4375 7 0.4375C6.89765 0.4375 6.80616 0.440189 6.72455 0.444806C6.26389 0.470846 6.0058 0.852903 5.9918 1.27034C5.98835 1.37218 5.98529 1.48577 5.98305 1.60983C5.56258 1.61461 5.17151 1.62222 4.809 1.63189C4.80673 1.49921 4.80352 1.37819 4.79987 1.27034C4.78587 0.852903 4.52777 0.470846 4.06712 0.444806C3.98551 0.440189 3.89401 0.4375 3.79167 0.4375ZM2.77083 7C2.77083 6.5973 3.0973 6.27083 3.5 6.27083H10.5C10.9027 6.27083 11.2292 6.5973 11.2292 7C11.2292 7.4027 10.9027 7.72917 10.5 7.72917H3.5C3.0973 7.72917 2.77083 7.4027 2.77083 7ZM3.5 9.1875C3.0973 9.1875 2.77083 9.51396 2.77083 9.91667C2.77083 10.3194 3.0973 10.6458 3.5 10.6458H7C7.4027 10.6458 7.72917 10.3194 7.72917 9.91667C7.72917 9.51396 7.4027 9.1875 7 9.1875H3.5Z" fill="#CC5C2D"/>
  </g>
  <defs>
    <clipPath id="clip0_33257_62168">
      <rect width="14" height="14" fill="white"/>
    </clipPath>
  </defs>
</svg>`

const timeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <g clip-path="url(#clip0_33257_62173)">
    <path d="M5.4227 0.0447008C5.98774 -0.0857855 6.55139 0.267173 6.68189 0.832201C6.81207 1.39707 6.46063 1.96093 5.89576 2.09138C5.23492 2.24401 4.61021 2.53185 4.06372 2.94041C2.65977 3.99012 1.91013 5.77033 2.14009 7.50817C2.37008 9.24611 3.55738 10.77 5.18618 11.4183C5.99548 11.7404 6.87626 11.8409 7.73736 11.7095C8.59833 11.5782 9.40841 11.2191 10.0848 10.6705C10.6245 10.2326 11.0646 9.68671 11.3754 9.06951C11.6362 8.55155 12.2671 8.34252 12.785 8.6033C13.3027 8.86401 13.5116 9.49504 13.2512 10.0129C12.8072 10.8947 12.1794 11.6759 11.4083 12.3015C10.4421 13.0853 9.28442 13.5972 8.05454 13.7849C6.82439 13.9726 5.56578 13.8295 4.40962 13.3693C2.07477 12.4399 0.389186 10.2756 0.0592281 7.78435C-0.270497 5.29282 0.794357 2.76363 2.80727 1.25876C3.5878 0.675305 4.47892 0.262719 5.4227 0.0447008ZM6.9977 2.97321C7.48095 2.97321 7.8727 3.36497 7.8727 3.84821V6.12458H9.53794C10.0212 6.12458 10.4129 6.51636 10.4129 6.99958C10.4128 7.48272 10.0211 7.87458 9.53794 7.87458H6.9977C6.51473 7.87434 6.12282 7.48258 6.1227 6.99958V3.84821C6.1227 3.36511 6.51466 2.97345 6.9977 2.97321ZM12.6975 4.85173C13.2694 4.75744 13.8101 5.1439 13.9047 5.7158C13.9576 6.03568 13.9884 6.36269 13.9963 6.69471C14.0102 7.27419 13.5517 7.75505 12.9723 7.7693C12.3927 7.78322 11.9104 7.3249 11.8963 6.74529C11.8907 6.5117 11.869 6.28246 11.8321 6.05895C11.7375 5.48683 12.1254 4.94634 12.6975 4.85173ZM10.6317 2.03805C11.0556 1.64237 11.7208 1.66612 12.1164 2.09001C12.3298 2.31863 12.5283 2.56158 12.7098 2.81736C13.0454 3.29023 12.9338 3.94597 12.461 4.28161C11.9881 4.61702 11.3323 4.50557 10.9967 4.03279C10.8695 3.85362 10.7308 3.68315 10.5811 3.52282C10.1854 3.09892 10.2078 2.43378 10.6317 2.03805ZM7.37368 0.834935C7.50933 0.271125 8.07725 -0.0759135 8.64106 0.0597399C8.95365 0.134967 9.25829 0.231288 9.55298 0.346849C10.0926 0.558623 10.3592 1.16748 10.1477 1.70721C9.93599 2.24707 9.32586 2.51363 8.78599 2.30193C8.58016 2.22122 8.36719 2.15348 8.14888 2.10096C7.58557 1.9651 7.2384 1.39839 7.37368 0.834935Z" fill="#CC5C2D"/>
  </g>
  <defs>
    <clipPath id="clip0_33257_62173">
      <rect width="14" height="14" fill="white"/>
    </clipPath>
  </defs>
</svg>`
